import { Col } from "antd";
import { styled } from "styled-components";

export const LayoutWrapper = styled(Col)`
  padding: 48px;
`;
